'use strict';

export default function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      type: 'scatter',
      height: 250,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {
      text: '１日の平均気温と消費電力の相関',
      style: { fontSize: '14px' }
    },
    legend: {enabled: false},
    xAxis: {
      title: {
        text: '１日の平均気温 [℃]'
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '消費電力 [kWh]',
        style: {'font-size': '13px'}
      }
    },
    tooltip: {
      enabled: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>１日の平均気温: " + this.x + " ℃</tspan>";
        tip_format += "<br/><tspan style='font-size: 12px'>消費電力: " + this.y + " kWh</tspan>";

        return tip_format;
      }
    },
    plotOptions: {
      column: {grouping: false}
    },
    series: [
      {
        name: '消費電力'
      }
    ]
  };
}



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/weather-stat-graph/temp-correlation-graph/temp-correlation-graph.config.js